import { Loading } from '../loading/loading';
import { DetailedFileInfo } from "../../types/detailed-file-info";
import { PdfPreview } from './pdf-preview';
import { ImagePreview } from './image-preview';
import { OfficePreview } from './office-preview';
import { FileNotFound } from './file-not-found';


export function FilePreview(props: { file?: DetailedFileInfo | null; loggingParams: string; }) {
    const { file } = props;

    if (typeof (file) === 'undefined') {
        return <Loading />
    }
    if (!file) {
        return <FileNotFound />
    }

    return (<>
        {(file.type === 'PDF' ?
            <PdfPreview url={file.links.filePreview + props.loggingParams} /> :
            file.type.startsWith('Microsoft') ?
                <OfficePreview url={file.links.filePreview + props.loggingParams} /> :
                file.type === 'Image' ?
                    <ImagePreview url={file.links.filePreview + props.loggingParams} />
                    : <div>No Preview Available</div>
        )}
    </>);
}
